import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './styles/index.css';
import './components/internationalization/i18n';
import App from './components/App';

ReactDOM.render(<App />, document.getElementById('root'));
